var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainingMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6667 4.58974C17.6667 3.90598 17.133 3.35043 16.4762 3.35043H9.74384V1.42735C9.74384 1.19231 9.55911 1 9.33333 1C9.10755 1 8.92282 1.19231 8.92282 1.42735V3.32906H2.19048C1.53366 3.32906 1 3.88461 1 4.56838V14.5897C1 15.2735 1.53366 15.8291 2.19048 15.8291H5.94663L3.81199 19.9957C3.70936 20.2094 3.77094 20.4658 3.97619 20.5726C4.03777 20.6154 4.09934 20.6154 4.16092 20.6154C4.3046 20.6154 4.44828 20.5299 4.53038 20.3803L6.87028 15.8504H8.92282V20.5726C8.92282 20.8077 9.10755 21 9.33333 21C9.55911 21 9.74384 20.8077 9.74384 20.5726V15.8504H11.7964L14.1363 20.3803C14.2184 20.5299 14.3621 20.6154 14.5057 20.6154C14.5673 20.6154 14.6289 20.594 14.6905 20.5726C14.8957 20.4658 14.9573 20.2094 14.8547 19.9957L12.72 15.8504H16.4762C17.133 15.8504 17.6667 15.2949 17.6667 14.6111V4.58974ZM16.8456 14.6111C16.8456 14.8248 16.6814 14.9957 16.4762 14.9957H2.19048C1.98522 14.9957 1.82102 14.8248 1.82102 14.6111V4.58974C1.82102 4.37607 1.98522 4.20513 2.19048 4.20513H16.4762C16.6814 4.20513 16.8456 4.37607 16.8456 4.58974V14.6111Z",
    fill: "#353434",
    stroke: "#353434",
    strokeWidth: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingMenu);
export default __webpack_public_path__ + "static/media/training-menu.3a7f5689c5ce820d0f21630750a48e6e.svg";
export { ForwardRef as ReactComponent };